<template>
  <div class="app-options-box-list">
    <OptionBox @next="next" v-for="option in options" :key="option.id" :option="option">
      <template v-for="slot in possibleChildSlotsFor('Horizontal')" v-slot:[`${slot.child}`]>
        <slot :name="`${slot.parent}`"></slot>
      </template>
    </OptionBox>
  </div>
</template>
<script>

import slotProxy from '@/mixins/slotProxy'
import OptionBox from './OptionBox.vue'

export default {
  name: 'OptionsBoxList',
  components: {
    OptionBox
  },
  mixins: [
    slotProxy()
  ],
  methods: {
    next (data) {
      this.$emit('next', data)
    }
  },
  props: {
    options: {
      type: Array,
      default: () => []
    }
  }
}
</script>
